<template>
    <div class="" v-if="$auth.check()">
        <div class="row">
            <div class="text-primary text-center col">
                <span v-if="$props.moreInfo" style="color:#888888;">
                     봉사시간 <img :src="require('@/assets/icon/que.png')" class="" @click="levelInfo()"/>
                </span>
                <h4 class="text-lg-center"> Lv.{{$root.$children[0].getLevelByMinute($auth.user().volunteerMinute).level}} ({{parseInt($auth.user().volunteerMinute/60)}} 시간)</h4>
            </div>
        </div>
        <div class="row my-1">
            <span class="col-sm-2"></span>
            <div class=" col-sm-8">
                <div class="progress" style="border-radius: 30px; height: 20px !important;;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                         :class="{'bg-danger':percentage >= 80,
                                'bg-warning':percentage >= 50 && percentage < 80,
                                'bg-success':percentage >= 30 && percentage < 50}"
                         role="progressbar" :aria-valuenow="$auth.user().volunteerMinute"
                         :aria-valuemin="$root.$children[0].getLevelByMinute($auth.user().volunteerMinute).min"
                         :aria-valuemax="$root.$children[0].getLevelByMinute($auth.user().volunteerMinute).max"
                         :style="`width: ${$root.$children[0].getLevelPercent($auth.user().volunteerMinute)}%;`">
                        <span class="sr-only">{{$root.$children[0].getLevelPercent($auth.user().volunteerMinute)}}% Complete</span>
                    </div>
                    <span class="progress-type" style="height: 20px; line-height: 1em;">Lv {{$root.$children[0].getLevelByMinute($auth.user().volunteerMinute).level}}</span>
                    <span class="progress-completed" style="height: 20px; line-height: 1em;">{{$root.$children[0].getLevelPercent($auth.user().volunteerMinute)}}%</span>
                </div>
            </div>
            <div class="col-sm-2 text-right">
              <span>
                <router-link :to="{name : 'mypage'}">{{$auth.user().name}}</router-link>님 어서오세요.
              </span> &nbsp;
                <!--<span @click="$auth.logout()">로그아웃 </span>-->
            </div>
        </div>
        <level-modal/>

        <br/>
    </div>
</template>

<script>
    import LevelModal from '@/components/LevelModal.vue'
    export default {
        name: 'MyLevel',
        components: {LevelModal},
        props: {
            moreInfo: Boolean
        },
        data() {
            return {
                level: 3,
                percentage: 0
            }
        },
        methods: {
            levelInfo(){
              this.$modal.show('LevelModal')
            },
        },
        created() {
            this.percentage = this.$root.$children[0].getLevelPercent(this.$auth.user().volunteerMinute);
        }
    }
</script>
<style>
    .progress {
        position: relative;
    }

    .progress > .progress-type {
        position: absolute;
        left: 0px;
        font-weight: 800;
        padding: 3px 30px 2px 10px;
        color: rgb(255, 255, 255);
        background-color: rgba(25, 25, 25, 0.2);
    }

    .progress > .progress-completed {
        position: absolute;
        right: 0px;
        font-weight: 800;
        padding: 3px 10px 2px;
    }
</style>

